import { apiSlice } from "./apiSlice";

export const latestNewsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addLatestNews: builder.mutation({
      query: (latestNewsData) => ({
        url: "/latestNews/addLatestNews",
        method: "POST",
        body: latestNewsData,
      }),
      invalidatesTags: ["LatestNews"],
    }),

    deleteLatestNews: builder.mutation({
      query: (id) => ({
        url: `/latestNews/deleteLatestNews/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["LatestNews"],
    }),

    updateLatestNews: builder.mutation({
      query: ({ latestNewsData, id }) => ({
        url: `/latestNews/updateLatestNews/${id}`,
        method: "PATCH",
        body: latestNewsData,
      }),
      invalidatesTags: ["LatestNews"],
    }),

    getAllLatestNews: builder.query({
      query: ({ page = 1, search, language } = {}) => {
        const params = new URLSearchParams();
        params.append("page", page);
        if (search) params.append("search", search);
        if (language) params.append("language", language);

        return {
          url: `/latestNews/getAllLatestNews?${params.toString()}`,
          method: "GET",
        };
      },

      providesTags: ["LatestNews"],
    }),
    getLatestNewsById: builder.query({
      query: (id) => ({
        url: `/latestNews/getLatestNewsById/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useAddLatestNewsMutation,
  useUpdateLatestNewsMutation,
  useDeleteLatestNewsMutation,
  useGetAllLatestNewsQuery,
  useGetLatestNewsByIdQuery,
} = latestNewsApi;
